import React from "react";
import Icon from "@ant-design/icons";


const CalendarSvg = () => (
    <svg fill="currentColor" width="1em" height="1em" viewBox="0 0 48 48">
        <path d="M43.48,8.21h-6.89v-2.99c0-.69-.56-1.25-1.25-1.25s-1.25.56-1.25,1.25v2.99H14.47v-2.99c0-.69-.56-1.25-1.25-1.25s-1.25.56-1.25,1.25v2.99h-7.14c-.69,0-1.25.56-1.25,1.25v32.75c0,.69.56,1.25,1.25,1.25h38.65c.69,0,1.25-.56,1.25-1.25V9.46c0-.69-.56-1.25-1.25-1.25ZM11.97,10.71v2c0,.69.56,1.25,1.25,1.25s1.25-.56,1.25-1.25v-2h19.62v2c0,.69.56,1.25,1.25,1.25s1.25-.56,1.25-1.25v-2h5.64v6.27H6.08v-6.27h5.89ZM6.08,40.95v-21.48h36.15v21.48H6.08Z"/>
        <path d="M16.02,22.65h-4.37c-.69,0-1.25.56-1.25,1.25s.56,1.25,1.25,1.25h4.37c.69,0,1.25-.56,1.25-1.25s-.56-1.25-1.25-1.25Z"/>
        <path d="M16.02,28.58h-4.37c-.69,0-1.25.56-1.25,1.25s.56,1.25,1.25,1.25h4.37c.69,0,1.25-.56,1.25-1.25s-.56-1.25-1.25-1.25Z"/>
        <path d="M16.02,34.51h-4.37c-.69,0-1.25.56-1.25,1.25s.56,1.25,1.25,1.25h4.37c.69,0,1.25-.56,1.25-1.25s-.56-1.25-1.25-1.25Z"/>
        <path d="M25.93,22.65h-4.37c-.69,0-1.25.56-1.25,1.25s.56,1.25,1.25,1.25h4.37c.69,0,1.25-.56,1.25-1.25s-.56-1.25-1.25-1.25Z"/>
        <path d="M25.93,28.58h-4.37c-.69,0-1.25.56-1.25,1.25s.56,1.25,1.25,1.25h4.37c.69,0,1.25-.56,1.25-1.25s-.56-1.25-1.25-1.25Z"/>
        <path d="M25.93,34.51h-4.37c-.69,0-1.25.56-1.25,1.25s.56,1.25,1.25,1.25h4.37c.69,0,1.25-.56,1.25-1.25s-.56-1.25-1.25-1.25Z"/>
        <path d="M35.85,22.65h-4.37c-.69,0-1.25.56-1.25,1.25s.56,1.25,1.25,1.25h4.37c.69,0,1.25-.56,1.25-1.25s-.56-1.25-1.25-1.25Z"/>
        <path d="M35.85,28.58h-4.37c-.69,0-1.25.56-1.25,1.25s.56,1.25,1.25,1.25h4.37c.69,0,1.25-.56,1.25-1.25s-.56-1.25-1.25-1.25Z"/>
    </svg>
);

const CalendarIcon = (props) => (
    <Icon component={ CalendarSvg } { ...props } />
);

export default CalendarIcon;
